<div class="summary-layout">
  <div class="summary">
    <h1>
      {{ 'summary.summary' | translate }}
    </h1>

    <div class="desktop-summary-layout">
      @if (!preloaders.summary) {
        @if (summaryApiData && !errors.summary) {
          <div class="desktop-label">
            <div class="label label--tooltiped">
              {{ 'summary.value' | translate }}
              <libero-tooltip-button [explainPerson]="'jiri_sindelar'" data-cy="summary-value-tooltip">
                {{ 'global.tooltips.value' | translate }}
              </libero-tooltip-button>
            </div>
            <div class="value">
              {{ summaryApiData.totalBalance | price:loggedUser.currencyCode }}
            </div>
          </div>
          <div class="desktop-label">
            <div class="label label--tooltiped">
              {{ 'summary.yield' | translate }}
              <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                {{ 'global.tooltips.yield' | translate }}
              </libero-tooltip-button>
            </div>
            <div
              class="value value--yield"
              [ngClass]="{ 'value--yield-positive': positiveYield }"
              >
              {{ positiveYield ? '+' : '' }} {{ (summaryApiData.actualYield > -1 && summaryApiData.actualYield < 0 ? 0 : summaryApiData.actualYield) | price:loggedUser.currencyCode }}
            </div>
          </div>
        } @else {
          <div class="api-error-container">
            {{ 'global.error.loadData' | translate }}
          </div>
        }
      } @else {
        <div class="header-preloader-container">
          <libero-preload-spinner [responsive]="true"></libero-preload-spinner>
        </div>
      }

      <div class="summary-btn">
        <libero-button
          routerLink="/money/deposit"
          label="{{ 'summary.addMoney' | translate }}"
          btnClasses="btn--primary btn--heading"
        ></libero-button>
      </div>
    </div>

    <div class="next-day-info">
      <div class="phone-content me-2">
        <libero-tooltip-button data-cy="trade-day-tooltip">
          {{ 'global.tooltips.tradeDay' | translate }}
        </libero-tooltip-button>
      </div>
      <a class="next-day-info-link" routerLink="/calendar">
        <div class="next-day-info-label me-2">
          {{ 'summary.nextTradeDay' | translate }}:
        </div>
        @if (!preloaders.summary) {
          <div class="next-day-info-date">
            @if (summaryApiData && !errors.summary) {
              {{ summaryApiData.nextRebalancingDate | date:'d. M. y' }}
            } @else {
              <div class="api-error-container">
                {{ 'global.error.loadData' | translate }}
              </div>
            }
          </div>
        } @else {
          <div class="rebalancing-preload-container">
            <libero-preload-spinner [responsive]="true"></libero-preload-spinner>
          </div>
        }
      </a>
      <div class="desktop-content ms-2">
        <libero-tooltip-button data-cy="trade-day-tooltip">
          {{ 'global.tooltips.tradeDay' | translate }}
        </libero-tooltip-button>
      </div>
    </div>
  </div>
</div>

<div class="charts-container">
  <div class="charts-layout">
    @if (!preloaders.chart) {
      <div class="chart-container">
        @if (!errors.chart) {
          @if (chartLabels.length > 0 || chartValues.length > 0) {
            <libero-charts
              [chartData]="chartValues"
              [xLabels]="chartLabels"
              [deposits]="deposits"
              [depositsLinePoints]="depositsLinePoints"
              [showDeposits]="chartForm.controls['showDepositsOnChart'].value"
              [userLocalization]="loggedUser.currencyCode"
              [isPercent]="isTwrSelected()"
            ></libero-charts>
          } @else {
            <div class="api-error-container">
              {{ 'global.error.noChartData' | translate }}
            </div>
          }
        } @else {
          <div class="api-error-container">
            {{ 'global.error.loadData' | translate }}
          </div>
        }
      </div>
    } @else {
      <div class="prealoader-container">
        <libero-preload-spinner></libero-preload-spinner>
      </div>
    }
    <div class="container-fluid chart-filters">
      <div class="row pt-1 pt-md-4">
        <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
          <div class="row">
            <div class="col-4 col-md-12 filtration-label">
              {{ 'summary.investment' | translate }}
            </div>
            <div class="col-8 col-sm-7 col-md-12">
              @if (preloaders.strategiesAndDrafts) {
                <div class="investments-preload-container">
                  <libero-preload-spinner [responsive]="true" ></libero-preload-spinner>
                </div>
              } @else if (errors.strategiesAndDrafts) {
                <div>
                  {{ 'global.error.loadData' | translate }}
                </div>
              } @else {
                <libero-dropdown
                  [itemSelectedControl]="chartForm.controls['investment']"
                  [availableList]="availableInvestment"
                  data-cy="summary-graph-investments-filter"
                ></libero-dropdown>
              }
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
          <div class="row">
            <div class="col-4 col-md-12 filtration-label">
              {{ 'summary.period' | translate }}
            </div>
            <div class="col-8 col-sm-7 col-md-12">
              <libero-dropdown
                [itemSelectedControl]="chartForm.controls['period']"
                [availableList]="filtrablePeriods"
                [displaySelectAllOption]="false"
                [initialValue]="filtrablePeriods[0]"
              ></libero-dropdown>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
          <div class="row">
            <div class="col-4 col-md-12 filtration-label filtration-label--tooltiped filtration-label--currency">
              <div class="phone-content">
                <libero-tooltip-button [explainPerson]="'monika_skodova'">
                  {{ 'global.tooltips.percentualInvestmentDevelopment' | translate }}
                </libero-tooltip-button>
              </div>

              {{ loggedUser.currencyCode }}/%

              <div class="desktop-content">
                <libero-tooltip-button [explainPerson]="'monika_skodova'">
                  {{ 'global.tooltips.percentualInvestmentDevelopment' | translate }}
                </libero-tooltip-button>
              </div>
            </div>
            <div class="col-8 col-sm-7 col-md-12">
              <libero-dropdown
                [itemSelectedControl]="chartForm.controls['priceMeasure']"
                [availableList]="currencyFilter"
                [displaySelectAllOption]="false"
                [initialValue]="currencyFilter[0]"
              ></libero-dropdown>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
          <div class="row">
            <div class="col-4 col-md-12 filtration-label">
              {{ 'summary.showDeposits' | translate }}
            </div>
            <div class="col-8 col-sm-7 col-md-12 switch-align">
              <libero-toggle-switch
                [formName]="chartForm.controls['showDepositsOnChart']"
                [disabled]="isTwrSelected()"
              ></libero-toggle-switch>
            </div>
          </div>
        </div>

        <div class="col-12 mt-5 col-md-12 mt-xl-0 offset-xl-1 col-xl-3 desktop-buttons-align">
          <div class="buttons-container">
            <libero-button label="{{ 'global.buttons.consultation' | translate }}" (click)="openModal()" btnClasses="btn--icon-text icon--secondary" svgIcon="accountant"></libero-button>
            <libero-button label="{{ 'global.buttons.videos' | translate }}" btnClasses="btn--icon-text" svgIcon="white-play-on-secondary-text" routerLink="/videos"></libero-button>
          </div>
        </div>
      </div>
      @if (loggedUser.managementType === 'EXECUTION_ONLY') {
        <hr class="mobile-divider">
      }
    </div>
  </div>
</div>

@if (loggedUser.managementType === 'EXECUTION_ONLY') {
  <div
    class="thematic-strategies-container"
    data-cy="thematic-strategies-container"
    >
    <div class="thematic-strategies-layout">
      <div class="thematic-strategies">
        @if (!preloaders.modelStrategies) {
          @if (!errors.modelStrategies) {
            <div class="swiper-container">
              <libero-model-strategy-carousel [modelStrategies]="modelStrategies!"></libero-model-strategy-carousel>
            </div>
          } @else {
            <div class="api-error-container">
              {{ 'global.error.loadData' | translate }}
            </div>
          }
        } @else {
          <div class="model-strategies-preloader-container">
            <libero-preload-spinner></libero-preload-spinner>
          </div>
        }
      </div>
    </div>
  </div>
}

<div class="my-investions-container" #investmentsSection data-cy="investments-section">
  <div class="my-investions-layout">
    <div class="my-investions">
      <h2>{{ 'summary.myGoals' | translate }}</h2>

      @if (!preloaders.strategiesAndDrafts) {
        @if (!errors.strategiesAndDrafts) {
          <div class="owned-strategies-container">
            <libero-owned-strategy-carousel [ownedStrategies]="ownedStrategies!" data-cy="owned-investments-carousel"></libero-owned-strategy-carousel>
          </div>
        } @else {
          <div class="api-error-container">
            {{ 'global.error.loadData' | translate }}
          </div>
        }
      } @else {
        <div class="owned-investments-prealoader">
          <libero-preload-spinner></libero-preload-spinner>
        </div>
      }

      <div class="action-buttons">
        @if (loggedUser.managementType === 'EXECUTION_ONLY') {
          <div class="label-tooltip-container">
            <div class="create-new-label" data-cy="summary-new-strategy-label">
              {{ 'global.createNewStrategy' | translate }}
            </div>
            <libero-tooltip-button [explainPerson]="'marketa_nemcova'">
              {{ 'global.tooltips.createNewStrategy' | translate }}
            </libero-tooltip-button>
          </div>
          <libero-button
            [routerLink]="'/strategy/pick'"
            label="{{ 'global.buttons.createStrategy' | translate }}"
            btnClasses="btn--primary btn--big"
            [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledStrategy' : null"
            data-cy="summary-new-strategy-button"
            [buttonDisabled]="disableInvestmentCreation"
          ></libero-button>
        }

        <div class="label-tooltip-container">
          <span class="create-new-label" data-cy="summary-new-portfolio-label">
            {{ 'global.createNewPortfolio' | translate }}
          </span>
          <libero-tooltip-button [explainPerson]="'marketa_nemcova'">
            {{ 'global.tooltips.createNewPortfolio' | translate }}
          </libero-tooltip-button>
        </div>
        <libero-button
          [routerLink]="'/portfolio/new'"
          label="{{ 'global.buttons.createPortfolio' | translate }}"
          btnClasses="btn--primary btn--big"
          [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledPortfolio' : null"
          data-cy="summary-new-portfolio-button"
          [buttonDisabled]="disableInvestmentCreation"
        ></libero-button>
      </div>
    </div>
  </div>
</div>
